import { Link } from "react-router-dom";
import { imageBaseurl } from "../utils/common";

const ChannelsList = ({channels})=>{
    return(
        <>
           {channels.map((ch, index) => (
          <Link key={index} to={`/channel/${ch.slug}`}>

            <div className="group flex flex-col items-center p-2.5 rounded-lg bg-white dark:bg-[#121212] border border-gray-200 dark:border-gray-700 hover:border-blue-500 transition-all duration-300 hover:shadow-lg">

              {/* Logo */}
              <div
                className="w-12 h-12 rounded-full flex items-center justify-center border-2 border-gray-200 dark:border-gray-700 group-hover:border-blue-500 transition"
                style={{ backgroundColor: '#1a1a2e' }}
              >
                <img
                  src={imageBaseurl + ch.logo}
                  alt={ch.channel_name}
                  className="w-8 h-8 object-contain"
                />
              </div>

              {/* Name */}
              <span className="mt-2 text-sm font-semibold text-center text-gray-800 dark:text-gray-200 group-hover:text-blue-500 transition">
                {ch.channel_name}
              </span>

              {/* Live Badge */}
              <span className="mt-1 flex items-center gap-1 text-[10px] font-bold text-red-500 animate-pulse">
                <span className="w-1.5 h-1.5 bg-red-500 rounded-full"></span>
                Watch
              </span>

            </div>

          </Link>
        ))}
        </>
    )
}

export default ChannelsList;